import { render, staticRenderFns } from "./SubmitTestTable.vue?vue&type=template&id=f757eddc&scoped=true&"
import script from "./SubmitTestTable.vue?vue&type=script&lang=ts&"
export * from "./SubmitTestTable.vue?vue&type=script&lang=ts&"
import style0 from "./SubmitTestTable.vue?vue&type=style&index=0&id=f757eddc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f757eddc",
  null
  
)

export default component.exports